<template>
  <div class="styles-outer-container">

    <div class="styles-inner-container" v-if="styles_basic.length > 0">
      <div class="d-flex justify-content-between">
        <div class="font-weight-bold text-white">
          <div class="d-inline-flex align-items-center">
            <span class="badge bg-gray-light text-normal">{{ 'FREE' | trans }}</span>
          </div>
        </div>
        <div class="text-muted font-weight-bold">{{ 'Free to use' | trans }}</div>
      </div>

      <div class="d-flex justify-content-center style-select-container">
        <div v-for="style in styles_basic" :class="{ 'active': activeStage.settings.style === style.conversion_style}"
             class="style-card"
             @click="changeStyle(style.conversion_style)">
          <div class="img-container"><img
              :alt="style.name"
              :srcset="`${style.path['1x']} 1x,  ${style.path['2x']} 2x, ${style.path['3x']} 3x,  ${style.path['4x']} 4x`"/></div>
          <div class="style-name">{{ style.name | trans }}</div>
          <div :class="{ 'active': activeStage.settings.style === style.conversion_style}"
               class="checkmark-box"
               @click="changeStyle(style.conversion_style)"><i class="fa fa-check"></i></div>
        </div>
      </div>
    </div>

    <div class="styles-inner-container" v-if="styles_starter.length > 0">
      <div class="d-flex justify-content-between">
        <div class="font-weight-bold text-white">
          <div class="d-inline-flex align-items-center">
            <span class="badge badge-starter">{{ 'STARTER' | trans }}</span>
          </div>
        </div>
        <div class="text-muted font-weight-bold">{{ 'Requires Subscription' | trans }}</div>
      </div>

      <div class="d-flex justify-content-center style-select-container">
        <div v-for="style in styles_starter" :class="{ 'active': activeStage.settings.style === style.conversion_style}"
             class="style-card"
             @click="changeStyleStarter(style.conversion_style)">
          <div class="img-container"><img
              :alt="style.name"
              :srcset="`${style.path['1x']} 1x,  ${style.path['2x']} 2x, ${style.path['3x']} 3x,  ${style.path['4x']} 4x`"/></div>
          <div class="style-name d-flex justify-content-between">{{ style.name | trans }} <span v-if="style.nsfw === true" class="lh-inherit badge badge-danger" data-toggle="tooltip" :title="tooltip_nsfw"><i class="lh-inherit far fa-info-circle"></i> NSFW</span></div>
          <div :class="{ 'active': activeStage.settings.style === style.conversion_style}"
               class="checkmark-box"
               @click="changeStyleStarter(style.conversion_style)"><i class="fa fa-check"></i></div>
        </div>
      </div>
    </div>

    <div class="styles-inner-container" v-if="styles_pro.length > 0">
      <div class="d-flex justify-content-between">
        <div class="font-weight-bold text-white">
          <div class="d-inline-flex align-items-center">
            <span class="badge badge-pro">{{ 'PRO' | trans }}</span>
          </div>
        </div>
        <div class="text-muted font-weight-bold">{{ 'Requires Subscription' | trans }}</div>
      </div>

      <div class="d-flex justify-content-center style-select-container">
        <div v-for="style in styles_pro" :class="{ 'active': activeStage.settings.style === style.conversion_style}"
             class="style-card"
             @click="changeStylePro(style.conversion_style)">
          <div class="img-container"><img
              :alt="style.name"
              :srcset="`${style.path['1x']} 1x,  ${style.path['2x']} 2x, ${style.path['3x']} 3x,  ${style.path['4x']} 4x`"/></div>
          <div class="style-name">{{ style.name | trans }}</div>
          <div :class="{ 'active': activeStage.settings.style === style.conversion_style}"
               class="checkmark-box"
               @click="changeStylePro(style.conversion_style)"><i class="fa fa-check"></i></div>
        </div>
      </div>
    </div>

    <div class="styles-inner-container" v-if="styles_ultimate.length > 0">
      <div class="d-flex justify-content-between">
        <div class="font-weight-bold text-white">
          <div class="d-inline-flex align-items-center">
            <span class="badge badge-ultimate">{{ 'ULTIMATE' | trans }}</span>
          </div>
        </div>
        <div class="text-muted font-weight-bold">{{ 'Requires Subscription' | trans }}</div>
      </div>

      <div class="d-flex justify-content-center style-select-container">
        <div v-for="style in styles_ultimate" :class="{ 'active': activeStage.settings.style === style.conversion_style}"
             class="style-card"
             @click="changeStyleUltimate(style.conversion_style)">
          <div class="img-container"><img
              :alt="style.name"
              :srcset="`${style.path['1x']} 1x,  ${style.path['2x']} 2x, ${style.path['3x']} 3x,  ${style.path['4x']} 4x`"/></div>
          <div class="style-name d-flex justify-content-between">{{ style.name | trans }} <span v-if="style.unrestricted === true" class="lh-inherit badge badge-light" data-toggle="tooltip" :title="tooltip_unassisted"><i class="lh-inherit far fa-info-circle"></i> Unassisted</span></div>
          <div :class="{ 'active': activeStage.settings.style === style.conversion_style}"
               class="checkmark-box"
               @click="changeStyleUltimate(style.conversion_style)"><i class="fa fa-check"></i></div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import user from './../../mixins/user.mixin';
import currentJob from './../../mixins/current_job.mixin';
import StylesManager from "../../manager/StylesManager";
import {PREMIUM_TYPE_BASIC, PREMIUM_TYPE_PRO, PREMIUM_TYPE_STARTER, PREMIUM_TYPE_ULTIMATE} from "../../const/premium_types.const";
import {EventBus} from "../../events/event.bus";
import {EVENT_PAYMENT_UNLOCK_PRO, EVENT_PAYMENT_UNLOCK_ULTIMATE, EVENT_PAYMENT_UNLOCK_STARTER} from "../../events/payment.events";
import {EVENT_APP_NAVIGATE} from "../../events/app.events";

export default {
  name: "StyleSelector",
  props: {},
  components: {},
  mixins: [
    store,
    user,
      currentJob
  ],
  data() {
    return {
      styles_basic: [],
      styles_pro: [],
      styles_starter: [],
      styles_ultimate: [],
      tooltip_unassisted: this.translate('Note: This style is not assisted in any way. No automated support or guidance is provided.'),
      tooltip_nsfw: this.translate('Note: This style may generate NSFW images.'),
    }
  },
  mounted: function () {
    if (this.isEducationalUser) {
      this.styles_basic = StylesManager.getStylesByTypeFilteredForEducation(PREMIUM_TYPE_BASIC);
      this.styles_starter = StylesManager.getStylesByTypeFilteredForEducation(PREMIUM_TYPE_STARTER);
      this.styles_pro = StylesManager.getStylesByTypeFilteredForEducation(PREMIUM_TYPE_PRO);
      this.styles_ultimate = StylesManager.getStylesByTypeFilteredForEducation(PREMIUM_TYPE_ULTIMATE);
    } else {
      this.styles_basic = StylesManager.getStylesByType(PREMIUM_TYPE_BASIC);
      this.styles_starter = StylesManager.getStylesByType(PREMIUM_TYPE_STARTER);
      this.styles_pro = StylesManager.getStylesByType(PREMIUM_TYPE_PRO);
      this.styles_ultimate = StylesManager.getStylesByType(PREMIUM_TYPE_ULTIMATE);
    }
  },
  created: function () {
  },
  methods: {
    changeStyle(style) {
      this.activeStage.settings.style = style;
      EventBus.$emit(EVENT_APP_NAVIGATE, `/${this.id}/inpaint/stage/${this.activeStage.id}`, {})
    },
    changeStyleStarter(style) {
      if (this.isStarterAndAboveUser === false) {
        EventBus.$emit(EVENT_PAYMENT_UNLOCK_STARTER, {});
      } else {
        this.activeStage.settings.style = style;
        EventBus.$emit(EVENT_APP_NAVIGATE, `/${this.id}/inpaint/stage/${this.activeStage.id}`, {})
      }
    },
    changeStylePro(style) {
      if (this.isProAndAboveUser === false) {
        EventBus.$emit(EVENT_PAYMENT_UNLOCK_PRO, {});
      } else {
        this.activeStage.settings.style = style;
        EventBus.$emit(EVENT_APP_NAVIGATE, `/${this.id}/inpaint/stage/${this.activeStage.id}`, {})
      }
    },
    changeStyleUltimate(style) {
      if (this.isUltimateUser === false) {
        EventBus.$emit(EVENT_PAYMENT_UNLOCK_ULTIMATE, {});
      } else {
        this.activeStage.settings.style = style;
        EventBus.$emit(EVENT_APP_NAVIGATE, `/${this.id}/inpaint/stage/${this.activeStage.id}`, {})
      }
    }
  },
  computed: {}
};
</script>
<style lang="scss">
.divider-style {
  border-bottom: 1px solid #595959;
}

.badge-ultimate {
  background: #1e1e1e;
  border: 1px solid #ccc;
}

.badge-starter {
  background: #7759c2;
}

.badge-pro {
  background: #1B5E20;
}

.styles-outer-container {
  gap: 40px;
  display: flex;
  flex-direction: column;
}

.styles-inner-container {
  gap: 20px;
  display: flex;
  flex-direction: column;
}

.style-select-container {
  gap: 10px;
  flex-wrap: wrap;
}

.style-card {
  width: 256px;
  height: 206px;

  border-radius: 9px;
  display: flex;
  flex-direction: column;
  border: 3px solid transparent;
  position: relative;

  &.active {
    border: 3px solid #1266F1;
    border-radius: 9px;
  }

  .img-container {
    overflow: hidden;
    height: 161px;
    max-height: 161px;
    width: 250px;
    max-width: 250px;
    border-radius: 9px 9px 0 0;
  }

  .checkmark-box {
    color: white;
    background: #1266F1;
    border-radius: 50%;
    position: absolute;
    padding: 5px;
    width: 32px;
    height: 32px;
    right: -15px;
    top: -15px;
    justify-content: center;
    align-items: center;
    display: none;

    &.active {
      display: flex !important;
    }
  }

  .style-name {
    font-size: 17px;
    align-items: center;
    flex: 1 0 auto;
    align-items: center;
    padding: 0 10px;
    display: flex;
    color: white;
    background: #343434;
    overflow: hidden;
    border-radius: 0 0 7px 7px;
  }
}

</style>
